import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { getRequestFormData, setRequestFormData } from "../../../store/slices/request-signature.slice";

function StepTwo({ instructors }: { instructors: any }) {
  const requestFormData = useAppSelector(getRequestFormData)
  const dispatch = useAppDispatch()

  return (
    <div className="signature_step__two">
      <h3 className="heading3 text-center">Select the instructor you want.</h3>
      <div className="input_group">
        <label>Choose an instructor</label>
        <select className="w-100" value={requestFormData.instructorId} onChange={(e) => dispatch(setRequestFormData({ instructorId: e.target.value }))}>
          <option value="">Select</option>
          {instructors?.map((instructor: any, i: number) => {
            return <option value={instructor?.userId?._id} key={i}>{instructor?.userId?.firstname} {instructor?.userId?.lastname}</option>
          })}
        </select>
      </div>
    </div>
  );
}

export default StepTwo;
